import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Creates customized Angular Material paginator labels for enterprise table screens.
 * @returns Configured MatPaginatorIntl instance.
 */
export function enterprisePaginatorIntl() {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Rows per page';
  intl.nextPageLabel = 'Next page';
  intl.previousPageLabel = 'Previous page';
  intl.firstPageLabel = 'First page';
  intl.lastPageLabel = 'Last page';
  intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) return 'Showing 0 of 0 records';
    const start = page * pageSize;
    const end = Math.min(start + pageSize, length);
    return `Showing ${start + 1}-${end} of ${length} records`;
  };
  return intl;
}
